import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceContractCategoryLookupComponent } from './service-contract-category-lookup.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [ServiceContractCategoryLookupComponent],
  exports: [ServiceContractCategoryLookupComponent]
})
export class ServiceContractCategoryLookupModule { }
